import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from '../services/data.service';
import { SettingService } from '../services/setting.service';

@Component({
  selector: 'app-language-selection',
  templateUrl: './language-selection.component.html',
  styleUrls: ['./language-selection.component.scss'],
  standalone: false
})
export class LanguageSelectionComponent {
  private router = inject(Router);
  private dataService = inject(DataService);
  private settingService = inject(SettingService);
  private sanitizer = inject(DomSanitizer);

  // Where the guest was headed when languageSelectionGuard sent them here.
  returnUrl = input<string | undefined>(undefined);

  logoUrl = computed(() => {
    const url = this.dataService.restaurant()?.logo_url;
    return url ? this.sanitizer.bypassSecurityTrustStyle(`url('${url}')`) : null;
  });
  languages = this.settingService.languages;

  selectLanguage(lang: string): void {
    this.settingService.applyLanguage(lang);
    this.router.navigateByUrl(this.safeReturnUrl());
  }

  // Only ever an in-app path - a crafted ?returnUrl must not bounce the guest off-site
  // (e.g. "//evil.com"), or loop them straight back here.
  private safeReturnUrl(): string {
    const url = this.returnUrl();
    const isInternal = !!url && url.startsWith('/') && !url.startsWith('//');
    return isInternal && !url.startsWith('/select-language') ? url : '/';
  }
}
